export const setProfilPrestataire = (profilPrestataire) => ({
    type: "SET_PROFIL_PRESTATAIRE",
    payload: profilPrestataire,
});
export const fetchProfilPrestataire =(token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const response = await fetch(`${apiUrl}/api/profilPrestataire`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors du chargement des propositions envoyées");
      }

      dispatch(setProfilPrestataire(data.profilPrestataire || []));
      return data.profilPrestataire;
    } catch (error) {
      console.error("Erreur fetchProfilPrestataire:", error);
      throw error;
    }
  };
};